export const computerVisionData = {
    bannerContent: {
        shortHeading: "Computer Vision Development Services",
        mainHeading: "Computer Vision <span>That Thinks</span> Like Humans, Scales Like Enterprises",
        description: "Transform visual data into actionable insights with our computer vision services. We build solutions that analyze images & videos to recognize patterns, detect objects, follow movements, & provide meaningful intelligence.",
    },
    services: {
        heading: "Enabling <span>Systems to See,</span> Understand, & Act With Precision",
        shortHeading: "Computer Vision Software Development Services",
        description: "We build powerful computer vision solutions to detect, analyze, & interpret images & videos. With 10+ years of experience, our expert computer vision engineers deliver custom software for startups & enterprises, improving efficiency, automation, & real-time insights.",
        cardsData: [
            {
                "title": "Computer Vision Consulting",
                "description": "Bitsclan offers expert computer vision in AI consulting services, creating custom solutions to extract insights from videos, images, & live streams. We combine deep learning & traditional methods to detect, track, & segment objects, improving accuracy & decision-making for businesses."
            },
            {
                "title": "Computer Vision Software Development",
                "description": "Our computer vision software development services help machines see, analyze, & understand images & videos. Using deep learning & machine learning algorithms, we create solutions to detect faces, objects, & patterns, turning visual data into actionable business insights."
            },
            {
                "title": "Object Recognition & Detection",
                "description": "Looking to build a powerful object detection system for industries like healthcare, agriculture, manufacturing, security, or facial & mask recognition? Our expert computer vision developers create reliable solutions for accurate AI object recognition & detection across multiple real-world applications."
            },
            {
                "title": "Facial & Optical Character Recognition (OCR)",
                "description": "Bitsclan’s deep learning development services deliver advanced facial & OCR solutions for security, data extraction, & personalization. From biometric access control & customer engagement to automated invoice, healthcare, & logistics processing, we build accurate systems that adapt to environments, languages, & handwriting styles with precision."
            },
            {
                "title": "Pose Estimation & Gesture Recognition",
                "description": "Using deep learning for computer vision, our pose estimation & gesture recognition solutions track human movements in real time. They detect joints & facial points, enabling sports analytics, physical therapy, & gaming with precise motion analysis & touchless interactions."
            },
            {
                "title": "3D Vision & Depth Estimation",
                "description": "3D Vision & depth estimation help machines to understand what an object looks like, how far away it is, & how it relates to its environment for better spatial awareness. Our team at Bitsclan designs innovative 3D vision systems for use across AR/VR, robotics, industrial automation, & autonomous /self-driving to increase accuracy, safety & operational efficiencies."
            },
            {
                "title": "Visual Search Technology",
                "description": "Visual search lets customers find products or any related information by uploading an image or video. Using advanced machine learning models like CLIP, DETR, & YOLO11, Bitsclan delivers accurate image-based recognition for e-commerce, retail, fashion, & catalog management, improving customer experiences."
            }
        ]
    },
    whyUsContent: {
        shortHeading: "Trusted Computer Vision Partner for Businesses",
        heading: " Measurable Impact. Continuous Innovation.",
        greenHeading: "Proven Expertise.",
        image: "/images/why-us-section/computer-vision-why-us.avif",
        content: "Companies trust us because we deliver reliable, high-performing computer vision solutions. With proven experiences, technologies, & a focus on measurable outcomes, we turn your challenges into opportunities.",
        stats: [
            {
                title: "Delivering Excellence Since",
                number: "2017"
            },
            {
                title: "Computer Vision Projects",
                number: "150+"
            },
            {
                title: "Computer Vision Engineers",
                number: "100+"
            },
            {
                title: "Computer Vision Solutions Across Industries",
                number: "14+"
            },
        ],
        cta: {
            text: "Partner With us Today",
            link: "/contact-us"
        }
    },
    testimonialData: {
        shortHeading: "Computer Vision Clients Testimonials",
        mainHeading: "Voices of <span>Enterprises</span> Driving Change With Us",
        description: "Our clients trust Bitsclan for innovative computer vision solutions. Hear how our services helped them achieve better accuracy, efficiency, & growth in their industries.",
        testimonials: [
            {
                name: "Michael Turner",
                enterprise: "Enterprise Automation",
                country: "Austin, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "CTO at BrightPath Logistics",
                profileImage: "/images/testimonials/michael.avif",
                logoImage: "/images/logo-2.png",
                text: "Bitsclan built a chatbot that now handles most of our customer queries. Response times are down to seconds, & our support team is free to focus on complex issues. It’s been a huge boost to efficiency & customer satisfaction.",
                serviceTags: [
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]
            },
            {
                name: "Sophie Keller",
                enterprise: "Healthcare AI",
                country: "Florida, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "Head of Digital Transformation at Meditech Solutions",
                profileImage: "/images/testimonials/sophie.avif",
                logoImage: "/images/logo-2.png",
                text: "With Bitsclan’s agentic AI, we’ve automated routine admin tasks like scheduling & reporting. Our staff now spends more time with patients, & errors have dropped noticeably. The solution fit right into our workflow.",
                serviceTags: [
                    { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
                    { title: "AI Automation", link: "/ai-automation-agency" },
                    { title: "Generative AI", link: "/generative-ai-development-services" }
                ]
            },
            {
                name: "Sarah Coleman",
                enterprise: "Construction & Industrial Equipment",
                country: "Illinois, US",
                countryFlagImage: "/images/testimonials/flags/usa-flag.png",
                designation: "Training & Product Specialist at American Moisture Test",
                profileImage: "/images/testimonials/sarah.avif",
                logoImage: "/images/testimonials/logo-amt.png",
                text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
                serviceTags: [
                    { title: "Custom Web Development", link: "/custom-software-development-services" },
                    { title: "Equipment Management System", link: "#" },
                    { title: "ERP Integration", link: "#" }
                ]
            }
        ]
    },
    caseStudyContent: {
        shortHeading: "Our Computer Vision Success Stories",
        heading: "Transformative <span>Vision Projects</span> Delivering Measurable Results",
        description: "At Bitsclan IT Solutions, our success stories showcase how computer vision transformed client operations by automating workflows, & unlocking new revenue opportunities across industries. Each project reflects measurable growth & real-world impact."
    },
    trendingInsights: {
        heading: "Insights Shaping the Future of Computer Vision & Deep Learning",
        description:
            "Learn the latest in computer vision development. Get practical insights, expert opinions, & strategies to stay ahead in the tech landscape.",
    },
    roadmapContent: {
        heading: "Our Proven <span>AI ML Development</span> Roadmap to Ensure Your Success",
        description:
            "As a leading ai development company in usa, we have developed a structured roadmap to ensure the success of your projects. From initial discovery to ongoing support, we follow a systematic approach that guarantees alignment with your business goals, delivers high-quality solutions, & provides continuous improvement. Here’s how we do it:",
        processData: [
            {
                title: "Discovery & Planning",
                description:
                    "We collaborate to understand your goals, create a design & development strategy, & align our AI/ML expertise with your business vision, ensuring seamless planning & high-quality results.",
                icon: "📋", // you can replace with an icon component or image path
            },
            {
                title: "Design & Proof of Concept",
                description:
                    "Turn your ideas into reality with a clear proof of concept. We design architectures & validate feasibility, ensuring custom AI development tailored to your needs.",
                icon: "🎨",
            },
            {
                title: "Implementation & Support",
                description:
                    "We bring your project to life with expert implementation. From setting clear goals to offering ongoing support, we ensure your AI solutions are always optimized.",
                icon: "⚙️",
            },
            {
                title: "Development & Testing",
                description:
                    "Our team of expert AI developers builds, tests, & refines your AI systems, ensuring smooth functionality. With rigorous validation, we deliver reliable & future-ready AI development services.",
                icon: "🧪",
            },
        ]
    },

    faqSection: {
        heading: "What Enterprises Need to Know About Computer Vision",
        questionAnswers: [
            {
                "id": "collapseOne",
                "question": "What is computer vision in AI?",
                "answer": "Computer vision is an artificial intelligence (AI) technology that allows computers to see & interpret images the same way as humans do. It relies on algorithms to recognize objects, detect patterns, & extract meaning from images or videos."
            },
            {
                "id": "collapseTwo",
                "question": "How reliable are computer vision systems in terms of accuracy?",
                "answer": "The accuracy of computer vision systems depends on the quality of data, how well the model was produced, & complexity of the task. When combined with the advanced AI techniques our solutions employ & sufficient training, we frequently achieve over 95% accuracy for object detection, image classification, & face recognition."
            },
            {
                "id": "collapseThree",
                "question": "Is computer vision software development just for show, or does it actually help?",
                "answer": "It truly helps. From spotting defects in factories to faster checkout in stores, computer vision cuts mistakes, speeds up decisions, & lets your team focus on everything else."
            },
            {
                "id": "collapseFour",
                "question": "What industries can benefit from Bitsclan's computer vision solutions?",
                "answer": "Bitsclan's computer vision solutions apply to dozens of industries, including agriculture, automotive, healthcare, manufacturing, retail, & security, assisting with tasks like categorizing & analyzing medical images, monitoring & tracking crops, identifying self-driving vehicles, conducting product or quality control checks, managing inventory, & monitoring for security & protection."
            },
            {
                "id": "collapseFive",
                "question": "Is Computer Vision the same as deep learning?",
                "answer": "No, computer vision & deep learning are not the same. Computer vision is a wider field related to teaching computers how to comprehend images & videos. Deep learning is one of the methods of computer vision using artificial neural networks to determine patterns in the data."
            }
        ]
    },

    companyCta: {
        heading: "Let’s Build the Computer Vision Solution Your Enterprise Needs.",
        subHeading: "Turn Your Visions into Reality",
        buttonText: "Book a Call",
    },

    engagementModels: {
        shortHeading: "Engagement Models",
        heading: "Tailored Computer Vision Solutions for Diverse Enterprise Needs",
        subheading: "Our engagement models are built to handle all types of computer vision development project needs, offering flexible options to meet unique goals, ensure scalability, & deliver efficient, client-focused solutions.",
        models: [
            {
                icon: "/images/engagement-model-gifs/hourly-icon.svg",
                index: 1,
                iconWidth: 40,
                title: " Staff Augmentation",
                description: "Our adaptable staffing approach helps strengthen your existing AI team with experienced computer vision developers. Whether you need to fill skill gaps or expand your team for a project, our team extension service quickly adds the right talent when you need it."
            },
            {
                icon: "/images/engagement-model-gifs/price-icon.svg",
                index: 2,
                iconWidth: 35,
                title: "Dedicated Teams",
                description: "At Bitsclan, we offer a skilled team of computer vision professionals who fully grasp your business needs & industry demands. Our AI experts work under an experienced project manager, ensuring smooth execution while you concentrate on your core business objectives."
            },
            {
                icon: "/images/engagement-model-gifs/retainer-icon.svg",
                index: 3,
                iconWidth: 35,
                title: "Project-Based Outsourcing Services",
                description: "We handle your entire computer vision project end-to-end. From planning & analysis to development, testing, & ongoing support, we ensure every phase is covered. Our team ensures reliable & efficient solutions for your business needs"
            }
        ],
        cta: {
            text: "Hire Computer Vision Experts",
            button: "Get Started Today",
            link: "/contact-us",
        },
    },
    industries: {
        shortHeading: "",
        heading: "",
        description: "",
        tabData: [
            {
                id: 1,
                slug: "healthcare",
                title: "Healthcare",
                description: "We specialize in healthcare computer vision & deep learning solutions. Our team builds AI models that analyze medical images, detect patterns, & support diagnosis, helping hospitals improve accuracy, speed up workflows, & stay compliant with healthcare standards.",
                image: "healthcare.avif",
                icon: "/images/heart.png",
            },
            // {
            //     id: 2,
            //     slug: "fintech",
            //     title: "Fintech",
            //     description: "We offer computer vision development services that help fintech companies process visual data for secure transactions, identity verification, fraud detection, & document scanning. Get accurate insights, safe operations, & real-time financial intelligence across web & mobile platforms.",
            //     image: "fintech.png",
            //     icon: "/images/Fintech.png",
            // },
            {
                id: 3,
                slug: "retail-ecommerce",
                title: "E-commerce & Retail",
                description: "Our computer vision solutions for E-commerce & Retail improve store & online experiences by managing inventory, understanding shopper behavior & optimizing product placement. Our solutions help brands relate to consumers, increase conversions & build loyal customers.",
                icon: "/images/ecommerce-icon.png",
                image: "ecommerce.avif",
            },
            {
                id: 4,
                slug: "real-estate",
                title: "Real Estate",
                description: "We assist real estate professionals in utilizing computer vision for process automation. Our intelligent solutions help simplify property inspections, project monitoring, & client management while ensuring hassle-free, accurate, & secure transactions every single time.",
                icon: "/images/RealEstate.png",
                image: "realestate.avif",
            },
            {
                id: 5,
                slug: "automotive-logistics",
                title: "Automotive & Logistics",
                description: "Our AI automation & workflow solutions empower the automotive & logistics industries by streamlining vehicle tracking, fleet management, supply chains, & inventory workflows. From managing operations & customer communications to real-time updates & seamless coordination, we help businesses boost efficiency, reduce complexity, & deliver a smoother experience for everyone.",
                icon: "/images/automotive-icon.png",
                image: "automotive.avif",
            },
            {
                id: 6,
                slug: "education",
                title: "Education",
                description: "We believe learning should be smooth & effective, & our computer vision solutions make it possible. From monitoring classrooms to analyzing student performance, we create smart systems that support students, teachers, & schools, helping everyone achieve better results.",
                icon: "/images/education-icon.png",
                image: "education.avif",
            },
            // {
            //     id: 7,
            //     slug: "insurance",
            //     title: "Insurance",
            //     description: "We help insurance companies work smarter by offering computer vision services. As a trusted computer vision development agency, we provide secure, scalable systems that adapt to the changing needs of the insurance industry.",
            //     icon: "/images/Insurance.png",
            //     image: "insurance.png",
            // },
            // {
            //     id: 8,
            //     slug: "logistics",
            //     title: "Logistics",
            //     description: "Efficiency drives logistics, & Bitsclan’s computer vision services make it seamless. We optimize supply chains with automated package tracking, fleet monitoring, & inventory checks, keeping operations organized & customers informed in real time.",
            //     icon: "/images/logistics.png",
            //     image: "logistics.avif",
            // },
            {
                id: 10,
                slug: "gaming-entertainment",
                title: "Entertainment & Gaming",
                description: "We empower the gaming & entertainment industry with innovative solutions that drive engagement, streamline operations, & boost revenue growth. Our expertise spans game development, live-ops, backend systems, & analytics-driven performance optimization. By incorporating AI in the right places—such as intelligent matchmaking, automated support, & behavioral insights—we deliver smoother experiences for players & measurable business impact for enterprises.",
                icon: "/images/industry-gaming-icon.png",
                image: "game.avif",
                imageAlt: "Professional gaming & entertainment solutions illustration"
            },
            // {
            //     id: 11,
            //     slug: "social-networking",
            //     title: "Social Networking",
            //     description: "We offer computer vision services for social media applications such as content recognition, image or video analysis automation, & secure data processing. Our services provide useful ways to improve user engagement, while keeping processes seamless & secure.",
            //     icon: "/images/SocialNetworking.png",
            //     image: "Social.png",
            // },
            // {
            //     id: 12,
            //     slug: "telecom",
            //     title: "Telecom",
            //     description: "Our computer vision development services for the telecom sector monitor network infrastructure, detect faults, & analyze usage patterns. By leveraging these insights, we help telecom companies improve efficiency, reduce errors, & provide better, more reliable services to their customers.",
            //     icon: "/images/Telecom.png",
            //     image: "telecom.png",
            // },
            // {
            //     id: 13,
            //     slug: "energy",
            //     title: "Energy",
            //     description: "We provide advanced computer vision services for the energy sector. From monitoring infrastructure & detecting faults to optimizing operations & ensuring safety, our visual intelligence tools help energy companies work smarter & more efficiently.",
            //     icon: "/images/Energy.png",
            //     image: "energy.png",
            // },
            // {
            //     id: 14,
            //     slug: "agriculture",
            //     title: "Agriculture",
            //     description: "We offer computer vision services in agriculture that help farmers monitor their crops, detect problems, & optimize management of resources. They can increase yields & promote smarter & sustainable practices.",
            //     icon: "/images/industries-icons/Agriculture.svg",
            //     image: "Agriculture.avif",
            // }
        ]
    },
    techStack: {
        tabs: [
            "Models & API's",
            "Vector Databases",
            "LLM Frameworks",
            "Deployment",
        ],

        tabItems: [
            {
                tab: "Models & API's",
                icon: "/images/computer-vision-stack-icons/open-ai.png",
            },
            {
                tab: "Models & API's",
                icon: "/images/computer-vision-stack-icons/mistral-ai.png",
            },
            {
                tab: "Models & API's",
                icon: "/images/computer-vision-stack-icons/meta.png",
            },
            {
                tab: "Models & API's",
                icon: "/images/computer-vision-stack-icons/grok.png",
            },
            {
                tab: "Models & API's",
                icon: "/images/computer-vision-stack-icons/mistral-ai.png",
            },
            { tab: "Vector Databases", icon: "/images/computer-vision-stack-icons/meta.png", },
            { tab: "Vector Databases", icon: "/images/computer-vision-stack-icons/mongo-db.png" },
            { tab: "Vector Databases", icon: "/images/computer-vision-stack-icons/milvus.png", },
            {
                tab: "LLM Frameworks",
                icon: "/images/computer-vision-stack-icons/haystack.jpg",
            },
            {
                tab: "LLM Frameworks",
                icon: "/images/computer-vision-stack-icons/langchain.png",
            },
            {
                tab: "LLM Frameworks",
                icon: "/images/computer-vision-stack-icons/nvidia.jpg",
            },
            {
                tab: "Deployment",
                icon: "/images/computer-vision-stack-icons/kubernates.png",
            },
            {
                tab: "Deployment",
                icon: "/images/computer-vision-stack-icons/vertex.png",
            },
            {
                tab: "Deployment",
                icon: "/images/computer-vision-stack-icons/google.png",
            },
            {
                tab: "Deployment",
                icon: "/images/computer-vision-stack-icons/hugging-face.png",
            },
        ]
    },
};